import React, { useCallback, useEffect } from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { getFormQuestionAttributeDisplayAs, setQuestionAttributeDisplayAs } from "reduxSlices/formBuilderSlice"
import { Select } from "shared/selects"

export const DROPDOWN = "dropdown"
export const CHECKBOX = "checkbox"

const MULTISELECT_QUESTION_DISPLAY_AS_OPTIONS = [
  { label: "Dropdown", value: DROPDOWN },
  { label: "Checkboxes", value: CHECKBOX },
]

const DisplayAs = ({ sectionIndex, questionIndex }) => {
  const dispatch = useDispatch()

  const questionDisplayAs = useSelector(getFormQuestionAttributeDisplayAs({ sectionIndex, questionIndex }))

  const updateDisplayAs = useCallback((newDisplayAs) => dispatch(setQuestionAttributeDisplayAs({
    sectionIndex, questionIndex, newDisplayAs,
  })), [sectionIndex, questionIndex, dispatch])

  useEffect(() => {
    if (!questionDisplayAs) updateDisplayAs(DROPDOWN)
  }, [questionDisplayAs, updateDisplayAs])

  return (
    <div className="flex-center mb-4">
      <div className="font-medium">Display</div>
      <Select
        className="text-sm"
        style={{ height: "32px" }}
        backspaceDelete={false}
        name={`sections[${sectionIndex}].questions[${questionIndex}].attributes.displayAs`}
        value={questionDisplayAs}
        options={MULTISELECT_QUESTION_DISPLAY_AS_OPTIONS}
        onChange={updateDisplayAs}
        label="select question display type"
      />
    </div>
  )
}

DisplayAs.propTypes = {
  sectionIndex: types.number.isRequired,
  questionIndex: types.number.isRequired,
}

export default DisplayAs
